















































































































import { defineComponent, computed, ref, nextTick, toRefs, PropType, watch, Ref } from '@vue/composition-api';
import { Message } from 'byted-vui';
import { isNumber } from 'lodash-es';
import { getDate, dayjs } from '@tt4b/ttam-utils';
import TipBox from '@/components/common/tip-box/index.vue';
import { i18n } from './../../../../i18n';
import { CurrencyOption } from './../../../../hooks/creation/account/useCurrencyOption/index';
import { useRequest, useUpdatePowerApi } from '@tt4b/ttam-hooks';
import { BaseMinDailyBudget } from '@tt4b/ttam-enums';

const name = 'ttam-budget-scheduled-budget-editor-dialog';

export default defineComponent({
  name,
  components: {
    TipBox,
  },
  props: {
    scheduledBudget: {
      type: Number,
      required: true,
    },
    scheduledBudgetTimestamp: {
      type: Number,
      required: true,
    },
    adId: {
      type: String,
      required: true,
    },
    currencyOption: {
      type: Object as PropType<CurrencyOption>,
      default: () => ({}),
      required: true,
    },
    timezone: {
      type: String,
      default: '',
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    minSchduledBudgetCalculated: {
      type: Number,
    },
  },

  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const { currencyOption, timezone, scheduledBudget, adId, minSchduledBudgetCalculated } = toRefs(props);

    const form = ref();
    const showConfirmRemove = ref(false);
    const hasStaleDayError = ref(false);

    const scheduledBudgetDraft: Ref<number | string> = ref(scheduledBudget.value || 0);
    const _scheduledBudgetDraft = computed(() => {
      const formBudget = scheduledBudgetDraft.value || 0;

      if (!formBudget || !Number(formBudget)) {
        return '';
      }

      return isNumber(formBudget) ? formBudget.toFixed(currencyOption.value.precision) : formBudget;
    });
    const _scheduledBudget = computed(() => Number(_scheduledBudgetDraft.value));

    watch(
      () => props.visible,
      newVal => {
        if (newVal) {
          scheduledBudgetDraft.value = scheduledBudget.value || 0;
        }
      },
    );

    const scheduledBudgetTimeFormat = computed(() => `YYYY-MM-DD HH:mm [(UTC]Z [ ${i18n.t('time_tomorrow')})]`);

    const getNextScheduledEffectiveTime = () => {
      const time = getDate(timezone.value)().add(1, 'd').hour(0).minute(0).millisecond(0) as dayjs.Dayjs;

      return {
        time,
        formattedString: time.format(scheduledBudgetTimeFormat.value),
      };
    };

    const scheduledBudgetEffectiveTime = ref(getNextScheduledEffectiveTime());
    const showDeleteBudget = computed(() => scheduledBudget.value);

    const budgetRule = computed(() => [
      {
        validator: (rule, value, callback) => {
          const min = minSchduledBudgetCalculated.value || BaseMinDailyBudget;
          const minBudget = min * currencyOption.value?.radio;
          if (Number(_scheduledBudgetDraft.value) < minBudget) {
            const msg = i18n.t('campaign_budget_max_hint', { min: minBudget });

            return callback(new Error(msg as string));
          }
          callback();
        },
        trigger: 'manual',
      },
    ]);

    const {
      run,
      isLoading: submitLoading,
      error,
    } = useRequest(
      useUpdatePowerApi,
      { adId: adId.value || '', data: { scheduledBudget: _scheduledBudget.value } },
      { manual: true },
    );

    function handleBudgeChange(val) {
      if (Number.isNaN(Number(val))) {
        scheduledBudgetDraft.value = '';
      }
      if (Number(val) < 0) {
        scheduledBudgetDraft.value = '0';
      }

      scheduledBudgetDraft.value = Number(val).toFixed(currencyOption.value?.precision);
      nextTick(() => form.value?.validate());
    }

    async function handleSubmit() {
      try {
        await form.value?.validate();
      } catch (_) {
        return;
      }

      if (getDate(timezone.value)().isSame(scheduledBudgetEffectiveTime.value.time, 'day')) {
        // 在 24 点前打开对话框，展示的生效时间是第二天，如果点击确认时当前时间已经到了第二天，那么展示警告提示，展示的生效时间更新到下一天
        scheduledBudgetEffectiveTime.value = getNextScheduledEffectiveTime();
        hasStaleDayError.value = true;

        return;
      }
      await run({ adId: adId.value, data: { scheduledBudget: _scheduledBudget.value } });
      if (!error.value) {
        const scheduledBudgetTimestamp = getNextScheduledEffectiveTime().time.unix();

        emit('scheduled-budget-change', _scheduledBudget.value);
        emit('scheduled-budget-timestamp-change', scheduledBudgetTimestamp);

        emit('update:visible', false);
        Message.success(i18n.t('common_success') as string);
      }
    }

    async function handleRemove() {
      try {
        Message.success(i18n.t('common_success') as string);
        // 将 scheduled_budget 传参为 0 时将从数据库中移除现存定时预算
        await run({ adId: adId.value, data: { scheduledBudget: 0 } });
        if (!error.value) {
          emit('scheduled-budget-change', 0);
          emit('scheduled-budget-timestamp-change', 0);
          emit('update:visible', false);
          console.log(Message);
          Message.success(i18n.t('common_success') as string);
        }
      } finally {
        showConfirmRemove.value = false;
      }
    }

    function showConfirmRemoveDialog() {
      showConfirmRemove.value = true;
      setTimeout(() => emit('update:visible', false), 100);
    }

    function hideConfirmRemoveDialog() {
      showConfirmRemove.value = false;
      emit('update:visible', true);
    }

    return {
      name,
      form,
      budgetRule,
      submitLoading,
      showDeleteBudget,
      showConfirmRemove,
      hasStaleDayError,
      scheduledBudgetEffectiveTime,
      _scheduledBudgetDraft,

      handleSubmit,
      handleRemove,
      handleBudgeChange,
      showConfirmRemoveDialog,
      hideConfirmRemoveDialog,
    };
  },
});
